import React from "react";
import { Context } from "./context";
import { Actions } from "./shared/Actions";
import { DetailRows } from "./shared/DetailRows";
import { Header } from "./shared/Header";
import { Modals } from "./shared/Modals";

/**
 * @param {{
 *  id: number;
 *  onClose: () => void;
 *  refetchAppointments?: () => void;
 * }} param0
 */
export function OutOfOffice({ id, onClose, refetchAppointments }) {
  const contextValue = {
    id,
    onClose,
    refetchAppointments: refetchAppointments || (() => {}),
    modals: {
      delete: Modals.Delete.useHandler(),
    },
  };

  return (
    <Context.Provider value={contextValue}>
      <div className="newPopupContent">
        <Header />
        <DetailRows />
      </div>
      <Actions />
      <Modals />
    </Context.Provider>
  );
}
